/*
 * Comcast CONFIDENTIAL
 *
 * Copyright 2003 - 2017 Comcast Corporation
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Comcast Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Comcast Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is unlawful and strictly forbidden unless prior written permission is obtained
 * from Comcast Corporation.
 */
//// CONTROLLER ////
(function () {
  'use strict';

  angular.module('comcast.settings').controller('UserSearchController', ['$location', '$state', '$stateParams', 'loginService', 'UserResourceFactory', function ($location, $state, $stateParams, loginService, UserResource) {
    /* PRIVATE : DATA */
    //Declare all private variables here

    /*
     * This is the `vm` object. It is a direct reference to the controller
     * which acts as our 'view-model' in angular. It also limits our need
     * to be accessing $scope directly. */

    /*jshint validthis:true*/
    var vm = this;
    /* BINDABLE : DATA */

    vm.searchParams = {};
    vm.jobClassifications = [];
    /* BINDABLE : METHODS*/

    vm.search = search;
    vm.clear = clear;
    vm.loadClassifications = loadClassifications;
    /* EVENTS */
    //Register any event listeners

    /* INITIALIZATION */
    //Call controller initialization method here

    _init();
    /* IMPLEMENTATION : BINDABLE */


    function search() {
      $state.go('users', vm.searchParams, {
        notify: true,
        inherit: false,
        reload: true
      });
    }

    function clear() {
      vm.searchParams = {};
    }

    function loadClassifications() {
      UserResource.getJobClassifications({}, function (classifications) {
        vm.jobClassifications = classifications.data;
      }, function () {
        vm.jobClassifications = [];
      });
    }
    /* IMPLEMENTATION : PRIVATE */
    // All private methods should start with '_' in order to distinguish them

    /**
     * Initialization for this controller.
     */


    function _init() {
      vm.searchParams = $stateParams;
      vm.loadClassifications();
    }
  }]);
})();